import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { formatDayLabel } from '../../utils/formatDate';

export default function ProgramDaySheet({
    isOpen,
    uniqueDates,
    selectedDate,
    onSelectDate,
    onClose
}) {
    if (!isOpen) return null;

    return (
        <div className="program-sheet" role="dialog" aria-modal="true" onClick={onClose}>
            <div className="program-sheet__content" onClick={e => e.stopPropagation()}>
                <div className="program-sheet__header">
                    <div className="program-sheet__title">Velg dag</div>
                    <button
                        type="button"
                        className="program__icon-btn"
                        onClick={onClose}
                        aria-label="Lukk"
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>

                <div className="program-sheet__list" role="listbox">
                    {uniqueDates.map(dk => {
                        const isActive = dk === selectedDate;

                        return (
                            <button
                                key={dk}
                                type="button"
                                className={`program-sheet__item ${isActive ? 'is-active' : ''}`}
                                onClick={() => onSelectDate(dk)}
                                role="option"
                                aria-selected={isActive}
                            >
                                {formatDayLabel(dk)}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
